import { useEffect, useState } from "react";
import ShareEventModal from "../Creator/Modal/ShareEventModal";

export const ShareButton = (isDisabled = false) => {
    // state for display action after share button clicked
    const [shareModalShow, setShareModalShow] = useState(false);

    return (
        <div className="w-100 position-relative">
            <button
                disabled={isDisabled == undefined || isDisabled == false}
                onClick={() => setShareModalShow(true)}
                className="btn btn-outline-blue btn-block share-icon shadow-none"
            >
                <img src="/images/icon/share.svg" alt="share" />
            </button>

            <ShareEventModal onHide={() => setShareModalShow(false)} show={shareModalShow} event_link={window.location.href} />
        </div>
    );
}

